import { graphql } from "@/lib/gql/__generated__";

export const RESERVATION_REQUEST_LIST_BY_UPDATED_DATE_FOR_MANAGEMENT_RESERVATION_SEARCH_REQUEST_QUERY = graphql(
	/* GraphQL */ `
		query ReservationRequestListByUpdatedDateForManagementReservationSearchRequest(
			$hotelID: ID!
			$from: String!
			$to: String!
			$reservationRequestStatus: ReservationRequestStatus!
		) {
			reservationRequestListByUpdatedDate(
				hotelID: $hotelID
				from: $from
				to: $to
				reservationRequestStatus: $reservationRequestStatus
			) {
				id
				hotelID
				hotelPrefecture
				hotelName
				reservations {
					hotelID
					reservationID
					reservationType
					repeaterType
					reservationStatus
					guestName
					guestNameKana
					guestTel
					guestEmail
					guestPostalCode
					guestAddress
					checkIn
					checkInTimeStart
					checkInTimeEnd
					checkOut
					reserveDate
					latestUpdateDate
					canceledDate
					numOfPeople
					numOfAdult
					numOfKids
					numOfRoom
					plan
					planCanceled
					room {
						roomID
						name
						date
						numOfPeople {
							adultNum
							kidsNum {
								age
								asCosleeping
							}
							uniqueRoomID
						}
					}
					roomCanceled {
						roomID
						name
						date
						numOfPeople {
							adultNum
							kidsNum {
								age
								asCosleeping
							}
							uniqueRoomID
						}
					}
					option {
						optionID
						name
						date
						amount
					}
					optionCanceled {
						optionID
						name
						date
						amount
					}
					discount
					questions {
						question
						answer
					}
					vouchers {
						name
						price
					}
					paymentMethod
					totalGuestCharge
					pricePlanTotal
					priceRoomTotal
					priceOptionTotal
					priceAdditionalFeeTotal
					priceDiscount
					isAcceptMailMagazine
					isNoShow
					memoByHost
					createdAt
				}
			}
		}
	`,
);
